import Image from "next/image"

import type { Colourway } from "@/features/catalog/catalog"
import { cn } from "@/lib/utils"

/**
 * A combo's mounts side by side, each in its colour: the middle one forward, the others turned in
 * behind it, so the pack reads as one picture.
 */
export function ComboTrio({
  colourways,
  sizes,
  className,
  priority = false,
}: {
  /** One per mount, in order. */
  colourways: Colourway[]
  sizes: string
  className?: string
  priority?: boolean
}) {
  const count = colourways.length
  const middle = (count - 1) / 2
  return (
    <div className={cn("relative flex items-end justify-center", className)}>
      {colourways.map((c, i) => {
        const offset = i - middle
        return (
          <div
            key={`${c.id}-${i}`}
            className="relative aspect-[4/5] w-[38%] shrink-0 overflow-hidden rounded-xl border border-white/[0.08] shadow-[0_18px_40px_rgb(0_0_0_/_0.55)]"
            style={{
              marginLeft: i === 0 ? 0 : "-9%",
              zIndex: 10 - Math.round(Math.abs(offset) * 2),
              transform: `translateY(${Math.abs(offset) * 6}%) rotate(${offset * 5}deg) scale(${1 - Math.abs(offset) * 0.08})`,
            }}
          >
            <Image
              src={c.image}
              alt=""
              fill
              sizes={sizes}
              priority={priority && i === Math.round(middle)}
              className="object-cover"
            />
          </div>
        )
      })}
    </div>
  )
}
